import { Component, OnDestroy, OnInit } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { createSelector, select, Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

import { CustomizationState } from "@app/user/customization/customization-store/customization.reducer";
import * as ManagementActions from "@app/user/customization/customization-store/management.actions";
import * as AbstractionManagement from "@helper/abstraction/management";
import { notNull } from "@helper/operators";

@Component({
    selector: "app-user-popup",
    templateUrl: "./user-popup.component.html",
    styleUrls: ["./user-popup.component.scss"]
})
export class UserPopupComponent implements OnInit, OnDestroy {
    public userList$?: Observable<AbstractionManagement.ManagementList>;
    public selectedUsers?: AbstractionManagement.ManagementList = [];
    private params: AbstractionManagement.ManagementListParams = {
        fullName: null,
        login: null,
        userStatuses: [{ id: "ACTIVE", name: $localize`Активные` }],
    };
    private unsubscribe$$: Subject<void> = new Subject<void>();
    private addedUsers?: AbstractionManagement.ManagementList = [];

    constructor(
        public config: DynamicDialogConfig,
        public ref: DynamicDialogRef,
        private readonly store: Store<CustomizationState>,
    ) { }

    public ngOnInit(): void {
        this.setData();
        const selectCustomizationState = (appState: any): CustomizationState => appState.customization;
        const selectManagementList = createSelector(selectCustomizationState, (state: CustomizationState) => state.managementList);
        this.userList$ = this.store.pipe(select(selectManagementList))
            .pipe(
                notNull(),
                takeUntil(this.unsubscribe$$),
                map(users => users?.filter(user => !this.addedUsers?.some(addedUser => addedUser?.id === user?.id)))
            );
    }

    public ngOnDestroy(): void {
        this.unsubscribe$$.next();
        this.unsubscribe$$.complete();
    }

    public updateFilterValue(formValue: AbstractionManagement.ManagementFilterFormValue): void {
        const newParams = { ...this.params };
        if (formValue) {
            newParams.fullName = formValue.fullName;
            this.params = newParams;
        }
        this.store.dispatch(ManagementActions.updateManagementFilter(newParams));
    }

    public close(): void {
        this.ref?.close();
    }

    public selectUsers(selectedUsers: AbstractionManagement.ManagementList): void {
        this.selectedUsers = selectedUsers;
    }

    public addUser(): void {
        this.ref.close(this.selectedUsers);
    }

    private setData(): void {
        this.config.width = "560px";
        this.config.height = "560px";
        this.config.header = $localize`Добавить сотрудника`;
        for (let k in this.config.data) {
            (this as any)[k] = this.config.data[k];
        }
    }
}
